/*
 * Public API Surface of exercise
 */

export * from './lib/podcasts-notification.service';
export * from './lib/exercise.component';
export * from './lib/exercise.module';
